import * as admin from "./admin";
import * as client from "./client";

const api = {
  ...admin,
  ...client
};

export default api;
